import Vue from 'vue'

import router from './router'

let analytics = {
  currentTime,
  setUserId
}

// initialize the analytics
export const analyticsConfig = {
  router: router,
  autoTracking: {
    exception: true
  },
  onReady: initializeAnalytics
}

export function initializeAnalytics () {
  Vue.$ga.time('Initialization', 'analytics', currentTime())
  analytics = Object.assign(analytics, Vue.$ga)
}

export function currentTime () {
  return Math.round(window.performance.now())
}

export function setUserId (userId) {
  Vue.$ga.set('userId', userId)
}

export default analytics



// WEBPACK FOOTER //
// ./src/analytics.js